import { Injectable } from '@angular/core';
import { delay, distinctUntilChanged, fromEvent, map, Observable, tap, throttleTime } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  private _scrollContainer: HTMLElement | null = null;

  public readonly SCROLL_ID = "scroll";

  public showGoTopBtn$?: Observable<boolean>;
  public hasScrollReachedEnd$?: Observable<boolean>;

  public get canContainerScroll(): boolean {
    if (this._scrollContainer) {
      let { offsetHeight, scrollHeight } = this._scrollContainer;
      return offsetHeight !== scrollHeight;
    }
    return false;
  }

  constructor() { }

  mountScrollService() {
    this._scrollContainer = document.getElementById(this.SCROLL_ID);
    if (this._scrollContainer) {
      this.showGoTopBtn$ = fromEvent<any>(this._scrollContainer, 'scroll').pipe(
        throttleTime(100),
        map((event: any) => {
          return (event.target as HTMLElement).scrollTop > 200;
        })
      );

      this.hasScrollReachedEnd$ = fromEvent<any>(this._scrollContainer, 'scroll').pipe(
        delay(100),
        map((event: any) => {
          let { scrollTop, offsetHeight, scrollHeight } = (event.target as HTMLElement);
          return Math.abs(scrollTop + offsetHeight - scrollHeight) < 2;
        }),
        distinctUntilChanged()
      );
    }
  }

  scrollToElement(element: HTMLElement): void {
    if (element) {
      let { scrollHeight } = element;
      this.scrollTop(scrollHeight);
    }
  }

  scrollTop(top: number = 0): void {
    this._scrollContainer?.scrollTo({ top });
  }

}
